// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/canvas/nodes/VideoAudioMergeNode.css */

.VideoAudioMergeNode-wrapper {
  padding: 12px;
  min-width: 320px;
}

/* ========== Handle 样式 ========== */

/* Handle 基础样式 */
.VideoAudioMergeNode-handle {
  width: 14px;
  height: 14px;
  border: 2px solid white;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.VideoAudioMergeNode-handle:hover {
  width: 18px;
  height: 18px;
  border-width: 3px;
}

/* 不同类型的 Handle 颜色区分 */
.VideoAudioMergeNode-handle-video {
  background: #8b5cf6;
  border-color: #8b5cf6;
}

.VideoAudioMergeNode-handle-audio {
  background: #ec4899;
  border-color: #ec4899;
}

.VideoAudioMergeNode-handle-output {
  background: #10b981;
  border-color: #10b981;
}

/* Handle 标签样式 */
.VideoAudioMergeNode-handle-label {
  position: absolute;
  top: -30px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.75);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s ease;
  z-index: 10;
}

/* 输出 Handle 的标签在底部显示 */
.VideoAudioMergeNode-handle-output .VideoAudioMergeNode-handle-label {
  top: auto;
  bottom: -30px;
}

/* 悬停时显示标签 */
.VideoAudioMergeNode-handle:hover .VideoAudioMergeNode-handle-label {
  opacity: 1;
}

/* ⚠️ 节点被选中时，一直显示标签（这是关键功能！） */
.react-flow__node.selected .VideoAudioMergeNode-handle .VideoAudioMergeNode-handle-label {
  opacity: 1;
}

/* 可点击的标签样式 */
.VideoAudioMergeNode-handle-label-clickable {
  cursor: pointer;
  user-select: none;
}

.VideoAudioMergeNode-handle-label-clickable:hover {
  background: rgba(0, 0, 0, 0.9);
  transform: translateX(-50%) scale(1.05);
}

.VideoAudioMergeNode-handle-label-clickable:active {
  transform: translateX(-50%) scale(0.98);
}

/* 输出 Handle 的可点击标签需要单独处理 transform */
.VideoAudioMergeNode-handle-output .VideoAudioMergeNode-handle-label-clickable:hover {
  transform: translateX(-50%) scale(1.05);
}

.VideoAudioMergeNode-handle-output .VideoAudioMergeNode-handle-label-clickable:active {
  transform: translateX(-50%) scale(0.98);
}

/* ========== 其他样式 ========== */

.VideoAudioMergeNode-error {
  background: #fee;
  color: #c00;
  padding: 8px;
  border-radius: 4px;
  margin-bottom: 12px;
  font-size: 13px;
}

/* 连接状态检测 */
.VideoAudioMergeNode-connection-status {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
  padding: 10px;
  background: #f9fafb;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
}

.VideoAudioMergeNode-status-item {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.VideoAudioMergeNode-status-item.connected {
  background: #d1fae5;
  color: #065f46;
  border: 1px solid #a7f3d0;
}

.VideoAudioMergeNode-status-item.disconnected {
  background: #fff;
  color: #6b7280;
  border: 1px solid #d1d5db;
}

.VideoAudioMergeNode-status-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  font-size: 11px;
  font-weight: bold;
}

.VideoAudioMergeNode-status-item.connected .VideoAudioMergeNode-status-icon {
  background: #10b981;
  color: white;
}

.VideoAudioMergeNode-status-item.disconnected .VideoAudioMergeNode-status-icon {
  background: #e5e7eb;
  color: #9ca3af;
}

.VideoAudioMergeNode-status-text {
  white-space: nowrap;
}

.VideoAudioMergeNode-config {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.VideoAudioMergeNode-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.VideoAudioMergeNode-field label {
  font-size: 13px;
  font-weight: 500;
  color: #374151;
}

.VideoAudioMergeNode-select {
  padding: 8px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  background: white;
  cursor: pointer;
}

.VideoAudioMergeNode-select:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* 主要操作类型选择器 */
.VideoAudioMergeNode-select-primary {
  background: linear-gradient(135deg, #f0f4ff 0%, #e8f0fe 100%);
  border-color: #667eea;
  font-weight: 500;
}

.VideoAudioMergeNode-select-primary:focus {
  outline: none;
  border-color: #764ba2;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2);
}

/* 视频拼接模式提示 */
.VideoAudioMergeNode-hint {
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  border: 1px solid #f59e0b;
  border-radius: 6px;
  padding: 10px 12px;
  font-size: 13px;
  color: #92400e;
  line-height: 1.4;
}

.VideoAudioMergeNode-slider {
  width: 100%;
  height: 6px;
  border-radius: 3px;
  background: #e5e7eb;
  outline: none;
  -webkit-appearance: none;
}

.VideoAudioMergeNode-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #3b82f6;
  cursor: pointer;
}

.VideoAudioMergeNode-slider::-moz-range-thumb {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #3b82f6;
  cursor: pointer;
  border: none;
}

.VideoAudioMergeNode-slider:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.VideoAudioMergeNode-advanced {
  border-top: 1px solid #e5e7eb;
  padding-top: 8px;
}

.VideoAudioMergeNode-advanced-toggle {
  width: 100%;
  padding: 8px;
  background: transparent;
  border: none;
  text-align: left;
  font-size: 13px;
  font-weight: 500;
  color: #6b7280;
  cursor: pointer;
  transition: color 0.2s;
}

.VideoAudioMergeNode-advanced-toggle:hover {
  color: #374151;
}

.VideoAudioMergeNode-advanced-toggle:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.VideoAudioMergeNode-advanced-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
  padding: 8px;
  background: #f9fafb;
  border-radius: 4px;
}

.VideoAudioMergeNode-field-small {
  display: flex;
  align-items: center;
  gap: 8px;
}

.VideoAudioMergeNode-field-small label {
  font-size: 12px;
  color: #6b7280;
  flex: 1;
}

.VideoAudioMergeNode-input {
  width: 80px;
  padding: 4px 8px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 13px;
}

.VideoAudioMergeNode-input:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.VideoAudioMergeNode-button-primary {
  width: 100%;
  padding: 10px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.VideoAudioMergeNode-button-primary:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.VideoAudioMergeNode-button-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.VideoAudioMergeNode-progress {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.VideoAudioMergeNode-progress-bar {
  width: 100%;
  height: 8px;
  background: #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
}

.VideoAudioMergeNode-progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  transition: width 0.3s ease;
}

.VideoAudioMergeNode-progress-text {
  font-size: 12px;
  color: #6b7280;
  text-align: center;
}

.VideoAudioMergeNode-output {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #e5e7eb;
}

.VideoAudioMergeNode-video-container {
  width: 100%;
  background: #000;
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 8px;
}

.VideoAudioMergeNode-video {
  width: 100%;
  display: block;
}

/* 云端 URL 展示区域 */
.VideoAudioMergeNode-url-section {
  background: #f0fdf4;
  border: 1px solid #86efac;
  border-radius: 6px;
  padding: 10px;
  margin-bottom: 8px;
}

.VideoAudioMergeNode-url-label {
  font-size: 12px;
  font-weight: 600;
  color: #16a34a;
  margin-bottom: 6px;
}

.VideoAudioMergeNode-url-container {
  display: flex;
  gap: 6px;
}

.VideoAudioMergeNode-url-input {
  flex: 1;
  padding: 6px 8px;
  font-size: 12px;
  font-family: 'Monaco', 'Menlo', 'Courier New', monospace;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  background: white;
  color: #374151;
  cursor: text;
}

.VideoAudioMergeNode-url-input:focus {
  outline: none;
  border-color: #16a34a;
  box-shadow: 0 0 0 2px rgba(22, 163, 74, 0.1);
}

.VideoAudioMergeNode-copy-button {
  padding: 6px 10px;
  background: #16a34a;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
}

.VideoAudioMergeNode-copy-button:hover {
  background: #15803d;
}

.VideoAudioMergeNode-actions {
  display: flex;
  gap: 8px;
}

.VideoAudioMergeNode-button-secondary {
  flex: 1;
  padding: 8px;
  background: #f3f4f6;
  color: #374151;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  transition: background 0.2s;
}

.VideoAudioMergeNode-button-secondary:hover:not(:disabled) {
  background: #e5e7eb;
}

.VideoAudioMergeNode-button-secondary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.VideoAudioMergeNode-info {
  font-size: 12px;
  color: #6b7280;
  text-align: center;
  margin-top: 6px;
}

`, "",{"version":3,"sources":["webpack://./src/components/canvas/nodes/VideoAudioMergeNode.css"],"names":[],"mappings":"AAAA,wDAAwD;;AAExD;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA,oCAAoC;;AAEpC,gBAAgB;AAChB;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,+BAA+B;EAC/B,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,6BAA6B;EAC7B,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,SAAS;EACT,aAAa;AACf;;AAEA,YAAY;AACZ;EACE,UAAU;AACZ;;AAEA,8BAA8B;AAC9B;EACE,UAAU;AACZ;;AAEA,aAAa;AACb;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA,qCAAqC;AACrC;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA,+BAA+B;;AAE/B;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,aAAa;AACb;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,OAAO;AACT;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,4DAA4D;EAC5D,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,eAAe;EACf,wDAAwD;EACxD,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":["/* src/components/canvas/nodes/VideoAudioMergeNode.css */\n\n.VideoAudioMergeNode-wrapper {\n  padding: 12px;\n  min-width: 320px;\n}\n\n/* ========== Handle 样式 ========== */\n\n/* Handle 基础样式 */\n.VideoAudioMergeNode-handle {\n  width: 14px;\n  height: 14px;\n  border: 2px solid white;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n}\n\n.VideoAudioMergeNode-handle:hover {\n  width: 18px;\n  height: 18px;\n  border-width: 3px;\n}\n\n/* 不同类型的 Handle 颜色区分 */\n.VideoAudioMergeNode-handle-video {\n  background: #8b5cf6;\n  border-color: #8b5cf6;\n}\n\n.VideoAudioMergeNode-handle-audio {\n  background: #ec4899;\n  border-color: #ec4899;\n}\n\n.VideoAudioMergeNode-handle-output {\n  background: #10b981;\n  border-color: #10b981;\n}\n\n/* Handle 标签样式 */\n.VideoAudioMergeNode-handle-label {\n  position: absolute;\n  top: -30px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(0, 0, 0, 0.75);\n  color: white;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 500;\n  white-space: nowrap;\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n  z-index: 10;\n}\n\n/* 输出 Handle 的标签在底部显示 */\n.VideoAudioMergeNode-handle-output .VideoAudioMergeNode-handle-label {\n  top: auto;\n  bottom: -30px;\n}\n\n/* 悬停时显示标签 */\n.VideoAudioMergeNode-handle:hover .VideoAudioMergeNode-handle-label {\n  opacity: 1;\n}\n\n/* ⚠️ 节点被选中时，一直显示标签（这是关键功能！） */\n.react-flow__node.selected .VideoAudioMergeNode-handle .VideoAudioMergeNode-handle-label {\n  opacity: 1;\n}\n\n/* 可点击的标签样式 */\n.VideoAudioMergeNode-handle-label-clickable {\n  cursor: pointer;\n  user-select: none;\n}\n\n.VideoAudioMergeNode-handle-label-clickable:hover {\n  background: rgba(0, 0, 0, 0.9);\n  transform: translateX(-50%) scale(1.05);\n}\n\n.VideoAudioMergeNode-handle-label-clickable:active {\n  transform: translateX(-50%) scale(0.98);\n}\n\n/* 输出 Handle 的可点击标签需要单独处理 transform */\n.VideoAudioMergeNode-handle-output .VideoAudioMergeNode-handle-label-clickable:hover {\n  transform: translateX(-50%) scale(1.05);\n}\n\n.VideoAudioMergeNode-handle-output .VideoAudioMergeNode-handle-label-clickable:active {\n  transform: translateX(-50%) scale(0.98);\n}\n\n/* ========== 其他样式 ========== */\n\n.VideoAudioMergeNode-error {\n  background: #fee;\n  color: #c00;\n  padding: 8px;\n  border-radius: 4px;\n  margin-bottom: 12px;\n  font-size: 13px;\n}\n\n/* 连接状态检测 */\n.VideoAudioMergeNode-connection-status {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 12px;\n  padding: 10px;\n  background: #f9fafb;\n  border-radius: 6px;\n  border: 1px solid #e5e7eb;\n}\n\n.VideoAudioMergeNode-status-item {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 10px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.VideoAudioMergeNode-status-item.connected {\n  background: #d1fae5;\n  color: #065f46;\n  border: 1px solid #a7f3d0;\n}\n\n.VideoAudioMergeNode-status-item.disconnected {\n  background: #fff;\n  color: #6b7280;\n  border: 1px solid #d1d5db;\n}\n\n.VideoAudioMergeNode-status-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  font-size: 11px;\n  font-weight: bold;\n}\n\n.VideoAudioMergeNode-status-item.connected .VideoAudioMergeNode-status-icon {\n  background: #10b981;\n  color: white;\n}\n\n.VideoAudioMergeNode-status-item.disconnected .VideoAudioMergeNode-status-icon {\n  background: #e5e7eb;\n  color: #9ca3af;\n}\n\n.VideoAudioMergeNode-status-text {\n  white-space: nowrap;\n}\n\n.VideoAudioMergeNode-config {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.VideoAudioMergeNode-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.VideoAudioMergeNode-field label {\n  font-size: 13px;\n  font-weight: 500;\n  color: #374151;\n}\n\n.VideoAudioMergeNode-select {\n  padding: 8px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 14px;\n  background: white;\n  cursor: pointer;\n}\n\n.VideoAudioMergeNode-select:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* 主要操作类型选择器 */\n.VideoAudioMergeNode-select-primary {\n  background: linear-gradient(135deg, #f0f4ff 0%, #e8f0fe 100%);\n  border-color: #667eea;\n  font-weight: 500;\n}\n\n.VideoAudioMergeNode-select-primary:focus {\n  outline: none;\n  border-color: #764ba2;\n  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2);\n}\n\n/* 视频拼接模式提示 */\n.VideoAudioMergeNode-hint {\n  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);\n  border: 1px solid #f59e0b;\n  border-radius: 6px;\n  padding: 10px 12px;\n  font-size: 13px;\n  color: #92400e;\n  line-height: 1.4;\n}\n\n.VideoAudioMergeNode-slider {\n  width: 100%;\n  height: 6px;\n  border-radius: 3px;\n  background: #e5e7eb;\n  outline: none;\n  -webkit-appearance: none;\n}\n\n.VideoAudioMergeNode-slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #3b82f6;\n  cursor: pointer;\n}\n\n.VideoAudioMergeNode-slider::-moz-range-thumb {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #3b82f6;\n  cursor: pointer;\n  border: none;\n}\n\n.VideoAudioMergeNode-slider:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.VideoAudioMergeNode-advanced {\n  border-top: 1px solid #e5e7eb;\n  padding-top: 8px;\n}\n\n.VideoAudioMergeNode-advanced-toggle {\n  width: 100%;\n  padding: 8px;\n  background: transparent;\n  border: none;\n  text-align: left;\n  font-size: 13px;\n  font-weight: 500;\n  color: #6b7280;\n  cursor: pointer;\n  transition: color 0.2s;\n}\n\n.VideoAudioMergeNode-advanced-toggle:hover {\n  color: #374151;\n}\n\n.VideoAudioMergeNode-advanced-toggle:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.VideoAudioMergeNode-advanced-content {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 8px;\n  padding: 8px;\n  background: #f9fafb;\n  border-radius: 4px;\n}\n\n.VideoAudioMergeNode-field-small {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.VideoAudioMergeNode-field-small label {\n  font-size: 12px;\n  color: #6b7280;\n  flex: 1;\n}\n\n.VideoAudioMergeNode-input {\n  width: 80px;\n  padding: 4px 8px;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  font-size: 13px;\n}\n\n.VideoAudioMergeNode-input:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.VideoAudioMergeNode-button-primary {\n  width: 100%;\n  padding: 10px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.VideoAudioMergeNode-button-primary:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n.VideoAudioMergeNode-button-primary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.VideoAudioMergeNode-progress {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.VideoAudioMergeNode-progress-bar {\n  width: 100%;\n  height: 8px;\n  background: #e5e7eb;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.VideoAudioMergeNode-progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);\n  transition: width 0.3s ease;\n}\n\n.VideoAudioMergeNode-progress-text {\n  font-size: 12px;\n  color: #6b7280;\n  text-align: center;\n}\n\n.VideoAudioMergeNode-output {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.VideoAudioMergeNode-video-container {\n  width: 100%;\n  background: #000;\n  border-radius: 6px;\n  overflow: hidden;\n  margin-bottom: 8px;\n}\n\n.VideoAudioMergeNode-video {\n  width: 100%;\n  display: block;\n}\n\n/* 云端 URL 展示区域 */\n.VideoAudioMergeNode-url-section {\n  background: #f0fdf4;\n  border: 1px solid #86efac;\n  border-radius: 6px;\n  padding: 10px;\n  margin-bottom: 8px;\n}\n\n.VideoAudioMergeNode-url-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #16a34a;\n  margin-bottom: 6px;\n}\n\n.VideoAudioMergeNode-url-container {\n  display: flex;\n  gap: 6px;\n}\n\n.VideoAudioMergeNode-url-input {\n  flex: 1;\n  padding: 6px 8px;\n  font-size: 12px;\n  font-family: 'Monaco', 'Menlo', 'Courier New', monospace;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  background: white;\n  color: #374151;\n  cursor: text;\n}\n\n.VideoAudioMergeNode-url-input:focus {\n  outline: none;\n  border-color: #16a34a;\n  box-shadow: 0 0 0 2px rgba(22, 163, 74, 0.1);\n}\n\n.VideoAudioMergeNode-copy-button {\n  padding: 6px 10px;\n  background: #16a34a;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.VideoAudioMergeNode-copy-button:hover {\n  background: #15803d;\n}\n\n.VideoAudioMergeNode-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.VideoAudioMergeNode-button-secondary {\n  flex: 1;\n  padding: 8px;\n  background: #f3f4f6;\n  color: #374151;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 13px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.VideoAudioMergeNode-button-secondary:hover:not(:disabled) {\n  background: #e5e7eb;\n}\n\n.VideoAudioMergeNode-button-secondary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.VideoAudioMergeNode-info {\n  font-size: 12px;\n  color: #6b7280;\n  text-align: center;\n  margin-top: 6px;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
